import { AspectScores } from 'types/blockwiseScores';
import { generateVaultApiUrl, createAxiosInstance } from 'utils/Api';

// Blockwise Scores are fetched from the `survey_group` viewset in Vault.
const apiUrl = generateVaultApiUrl('/api/v2/survey_group/');
const axiosInstance = createAxiosInstance(apiUrl);

export const fetchAspectScores = async (
  surveyGroupId: number,
  startDate: string,
  endDate: string,
  divisionId?: number,
): Promise<AspectScores> => {
  const response = await axiosInstance.get<AspectScores>(`${surveyGroupId}/aspect_scores/`, {
    params: {
      start_date: startDate,
      end_date: endDate,
      division_id: divisionId,
    },
  });
  return response.data;
};
